import React, { createContext, ReactNode, useEffect, useState } from "react";
import { jsPDF } from "jspdf";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { Alert, Button, Form, Input, Modal, Slider, Space, Typography } from "antd";
import axios from "axios";
import { useContext } from "react";
import Icon from "@assets/icon_config";
import './pdf.scss'
import memberDetailsService from "@services/memberDetails.service";
import { FormInstance } from "antd/es/form";
import membersService from "@services/members.service";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import html2canvas from "html2canvas";

type EmailError = {email: string, error: string}
type Notification = {status: 'success' | 'error' | 'warning', message: string, autoclose?: boolean}

export type UsePdfProps = { 
  contentSelecter?: string,
  title?: string
}

type Validator = (_: any, value: string[], callback: (err?: string) => void) => void

export type UsePdf = (props: UsePdfProps) => {
  isOpen?: boolean
  setisOpen?: (isOpen: boolean) => void
  loading?: boolean
  notification?: Notification
  download?: () => void
  isMail?: boolean
  setisMail?: (isMail: boolean) => void
  sendEmail?: (values: any) => void
  zoom?: number
  setzoom?: (zoom: number) => void
  emailForm?: FormInstance<any>
  transformTo?: (value: string) => string[]
  emailValidation?: Validator
  closeEmailForm?: () => void
}

const usePdf: UsePdf = ({ contentSelecter = '.pdf-modal-wrapper .pdf-content', title }) => {
  const [isOpen, setisOpen] = useState<boolean>(false)
  const [fonts, setfonts] = useState<any[]>([])

  const [isMail, setisMail] = useState<boolean>(false)

  const allowedClients = ['Mycare', 'Tredence']
  const [allowedDomains, setallowedDomains] = useState<string[]>([])

  const [loading, setloading] = useState<boolean>(false)
  const [notification, setnotification] = useState<Notification>()

  const [emailForm] = Form.useForm()

  const currentMember = membersService?.getCurrentMember || {}

  useEffect(
    () => {
      console.log("usePdf.useEffect");
      if (notification && notification.autoclose) {
        setTimeout(
          () => {
            setnotification(undefined)
          },
          2000
        )
      }
    },
    [notification]
  )

  useEffect(
    () => {
      console.log("usePdf.useEffect");
      axios.get(`${process.env.REACT_APP_API_BASE_URI}/domain/domains`)
        .then(
          response => {
            const domains = response.data?.data?.domains || []
            const allowedDomains = domains.filter(
              (domain: any) => allowedClients.includes(domain.client_name)
            ).map(
              (domain: any) => domain.user_domain_name
            )

            setallowedDomains(allowedDomains)
          }
        )
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(
    () => {
      console.log("usePdf.useEffect");
      Promise.all(
        [
          axios.get('/fonts/fira-sans.txt'),
          axios.get('/fonts/fira-sans-bold.txt'),
          axios.get('/fonts/fira-sans-500.txt'),
        ]
      ).then(
        (responses) => {
          let weights = ['normal', 'bold', '500']
          setfonts(
            responses.map(
              (response, index) => {
                return {
                  weight: weights[index],
                  content: response.data
                }
              }
            )
          )
        }
      )
    },
    []
  )

  const pdfPassword = useGlobalInformationStore(state => state.secrets?.reactAppPdfPassword)

  const getPdf = () => {
    return new Promise<jsPDF>((resolve, reject) => {
      const content = document.querySelector(contentSelecter) as HTMLElement | null;
      if (!content) {
        reject(new Error("PDF content not found!"));
        return;
      }
  
      const isSummaryReport = title === "summary-report";
      if (isSummaryReport) {
        // Separate condition for creating img from svg
        html2canvas(content, { scale: 2, useCORS: true, allowTaint: true })
          .then((canvas) => {
            const marginX = 30;
            const marginY = 30;
            const imgWidth = 750;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            const pdf = new jsPDF({
              orientation: "p",
              unit: "px",
              format: [800, imgHeight + 2 * marginY],
              compress: true,
            });

            const imgData = canvas.toDataURL("image/png");

            pdf.addImage(imgData, "PNG", marginX, marginY, imgWidth, imgHeight);
            resolve(pdf);
          })
          .catch((error) => {
            reject(error);
          });
      } else {
    const content = document.querySelector(contentSelecter);

    const head = document.querySelector("head");

    let html = `
      <html>
        <head>
          ${head?.innerHTML}
        </head>
        <body>
          <div class="pdf-print-area" style="width: 900px; height: auto">
            ${content?.innerHTML}
          </div>
        </body>
      </html>
  `;

    // const win = window.open("about:blank", "_blank");
    // win?.document.write(html);

    const password = pdfPassword

    const pdf = new jsPDF(
      {
        orientation: 'p',
        unit: 'px',
        format: [960, (content?.clientHeight || 200) + 60],
        compress: true,
        encryption: {
          ownerPassword: password,
          userPassword: password
        }
      }
    );

    fonts.forEach(
      font => {
        const filename = `fira-sans-${font.weight}.ttf`
        pdf.addFileToVFS(filename, font.content)
        pdf.addFont(filename, 'Fira Sans', '', font.weight)
      }
    )

    // console.log(pdf.getFontList())
    // pdf.setFont('Fira Sans', 'normal', 'normal')
        pdf.html(html, {
          filename: 'utilization-review-report.pdf',
          margin: [30, 30, 30, 30],
          html2canvas: {
            svgRendering: true
          },
          callback: (pdf) => {
            // const url = pdf.output('bloburl')
            // window.open(url, '_blank')
            // setloading(false)
            // setnotification(undefined)
            // return reject('hi')
            resolve(pdf)
          },
        });
      }
    })
  }

  const download = () => {
    if (loading) {
      return
    }

    setloading(true)
    setnotification({status: 'warning', message: 'Download will start soon'})

    getPdf()
      .then(
        (pdf: jsPDF) => {
          const url = pdf.output("bloburl")
          
          const downloadLink = document.createElement('a')
          downloadLink.href = url.toString()
          downloadLink.download = `${(currentMember?.patient_name || '').toLowerCase().replaceAll(' ', '').replaceAll(',', '_')}-${title}.pdf`
          downloadLink.style.display = 'none'
          document.body.append(downloadLink)
          downloadLink.click()
          
          setTimeout(
            () => {
              downloadLink.remove()
              setnotification({status: 'success', message: 'Report Downloaded Successfully', autoclose: true})
              setloading(false)
            },
            3000
          )
        }
      )
  };

  const transformTo = (value: string) => {
    const emails = (value || '').trim().split(';')
      .map(email => email.trim())
      .filter(email => !!email)

    return emails
  }

  const emailValidation = (_: any, value: string[], callback: (msg?: string) => void) => {
    if (!value.length) {
      callback('To address is required')
      return 
    }
    let emailErrors: Array<EmailError | null> = value.map(
      email => {
        const emailDomain = email.split('@').pop()
        const isAllowed = allowedDomains.includes(emailDomain || '')

        let error = null
        if (!email.match(/^\S+@\S+\.\S+$/)) {
          error = 'INVALID'
        } else if (!isAllowed) {
          error = 'NOT_ALLOWED'
        }

        return error ? {
          email,
          error
        } : null
      }
    ).filter(error => !!error)

    if (emailErrors.length > 0) {
      callback('To address is invalid or not allowed')
      return
    }
    callback()
  }

  const sendEmail = (values: any) => {
    const emails = transformTo(values.to as string)
    if (!emails.length || loading) {
      return 
    }

    setloading(true)
    setnotification({status: 'warning', message: 'Sending...'})

    getPdf()
      .then(
        (pdf: jsPDF) => {
          const datauri = pdf.output('datauristring')
          
          memberDetailsService.sendUtilizationReviewReport(emails, datauri, currentMember?.patient_name || '').subscribe({
            next: (v) => {
              // const response = v.data.data;
              setnotification({status: 'success', message: '“Utilization Review Report” sent sucessfully', autoclose: true})
              setloading(false)
              closeEmailForm()
            },
            error: (e) => {
              console.log(e);
              setnotification({status: 'error', message: 'Technical Error!', autoclose: true})
              setloading(false)
            },
          });
        }
      )
  }

  const closeEmailForm = () => {
    setisMail && setisMail(false)
    emailForm.resetFields()
  }

  const [zoom, setzoom] = useState<number>(1)

  return {
    isOpen,
    setisOpen,
    loading,
    notification,
    download,
    isMail,
    setisMail,
    sendEmail,
    zoom,
    setzoom,
    emailForm,
    transformTo,
    emailValidation,
    closeEmailForm
  };
};

export const PdfContext = createContext<ReturnType<typeof usePdf>>(
  {
    isOpen: false
  }
)

export const PdfProvider: React.FC<UsePdfProps> = ({ children, ...props }) => {
  const pdf = usePdf(props)

  return (
    <PdfContext.Provider value={pdf}>
      {children}
    </PdfContext.Provider>
  )
}

export const usePdfContext = () => useContext(PdfContext)

export const PdfModalFooter: React.FC<{title: ReactNode}> = (props) => {
  const {
    download,
    isMail,
    setisMail,
    sendEmail,
    zoom,
    setzoom,
    emailForm,
    transformTo,
    emailValidation,
    closeEmailForm
  } = usePdfContext();

  const [isError, setisError] = useState<boolean>(true)
  const isSummaryReport = props.title === "Summary Report";  

  if (isMail) {
    return (
      <Form
        form={emailForm}
        name='email'
        layout='inline'
        onFinish={sendEmail}
        onFieldsChange={
          e => {
            setisError(emailForm?.getFieldsError().some(field => field.errors.length > 0) || false)
          }
        }
      >
        <Form.Item
          name='to'
          label='Email To:'
          className="input-email"
          rules={
            [
              {
                transform: transformTo,
                validator: emailValidation
              }
            ]
          }
        >
          <Input />
        </Form.Item>
        <Form.Item wrapperCol={{ span: 14, offset: 4 }}>
          <Button type="default" htmlType="button" onClick={() => closeEmailForm && closeEmailForm()}>
            Cancel
          </Button>
        </Form.Item>
        <Form.Item wrapperCol={{ span: 14, offset: 4 }}>
          <Button type="primary" htmlType="submit" disabled={isError}>
            Send
          </Button>
        </Form.Item>
      </Form>
    )
  }

  return (
    <Space size={"large"}>
      <Space>
        {!isSummaryReport && (
          <Button type="default" onClick={() => setisMail && setisMail(true)}>
            <Icon name={"email"} />
          </Button>
        )}
        <Button type="default" onClick={() => download && download()}>
          <Icon name={"download"} />
        </Button>
      </Space>
      {!isSummaryReport && (
        <Space className="zoom-wrapper">
          <Button type="text" onClick={() => {
            let zoomV = zoom || 1
            if (zoomV > 0.1) {
              setzoom && setzoom(zoomV - 0.1)
            }
          }}>
          <Typography.Text>-</Typography.Text>
          </Button>
          <Slider
            className="zoom-slider"
            min={0.1}
            max={2}
            value={zoom}
            onChange={setzoom}
            step={0.1}
            tooltipVisible={false}
          />
          <Button type="text" onClick={() => {
            let zoomV = zoom || 1
            if (zoomV < 2) {
              setzoom && setzoom(zoomV + 0.1)
            }
          }}>
          <Typography.Text>+ {((zoom || 1) * 100).toFixed()}%</Typography.Text>
          </Button>
        </Space>
      )}
    </Space>
  )
}

export const PdfModalHeader: React.FC<{title: ReactNode}> = (props) => {
  const { notification } = usePdfContext();

  return (
    <Space>
      {props.title}
      {
        notification && 
          <Alert
            type={notification.status}
            message={
              <Space>
                <ExclamationCircleOutlined />
                <Typography.Text>
                  {notification.message}
                </Typography.Text>
              </Space>
            }
            className={`notification status-${notification.status}`}
          />
      }
    </Space>
  )
}

export const PdfModal: React.FC<{title: ReactNode}> = (props) => {
  const { isOpen, setisOpen, zoom } = usePdfContext();

  const closeModel= (e : any) => {
    e.stopPropagation();
    setisOpen && setisOpen(false)
  }

  return (
    <Modal
      onCancel={(e) =>  closeModel(e)}
      title={<PdfModalHeader title={props.title} />}
      footer={<PdfModalFooter title={props.title} />}
      wrapClassName="pdf-modal-wrapper"
      visible={isOpen}
      width={'80%'}
      destroyOnClose
    >
      <div className="pdf-content-wrapper" style={{zoom: zoom}}>
        <div className="pdf-content">
          {props.children}
        </div>
      </div>
    </Modal>
  );
};
